<template>
  <div id="app" :class="[whitePage ? 'app--white' : '', bigPage ? 'layout--tall' : '', noMargin ? 'no-margin' : '', getShowPopin ? 'popin-deploy' : '', page ? page : '']">
    <div class="wrapper">
      <div class="app-header clearfix">
        <div class="app-header--left">
          <transition name="fadeIn">
            <template v-if="showIndic">
              <div class="app-header--indic">
                <div>
                  18+
                </div>

                <div>
                  1 à 60 millions<br> de joueurs
                </div>
              </div>
            </template>
          </transition>

          <transition name="fadeIn">
            <template v-if="!showIndic">
              <div class="app-header--logo">
                <router-link to="/">
                  <img src="~@/img/logo_header.png" alt="Passement de jambes" v-if="!getMobile">
                  <img src="~@/img/logo_mobile.png" alt="Passement de jambes" v-if="getMobile">
                </router-link>
              </div>
            </template>
          </transition>
        </div>

        <div class="app-header--right">
          <menu-comp></menu-comp>
        </div>
      </div>

      <div class="app-content">
        <router-view></router-view>
      </div>

      <div class="app-footer clearfix">
        <a href="http://www.p2j.fr/" target="_blank">
          <img src="~@/img/logo_footer.png" alt="Passement de jambes">
        </a>
      </div>
    </div>

    <div class="app-rays">
      <div class="app-rays--container">
        <span v-for="n in 50"></span>
      </div>
    </div>
  </div>
</template>

<script>
  // import TweenLite from 'gsap';
  import MenuComp from '~components/ui/menu/Menu';
  import dataQuestion from '../data/questions.json';
  import dataCharacters from '../data/characters.json';
  import dataEnd from '../data/end.json';

  export default {
    name: 'app',
    components: {
      MenuComp,
    },
    data() {
      this.$store.commit('setCharactersData', dataCharacters.characters);
      this.$store.commit('setQuestionsData', dataQuestion);
      this.$store.commit('setEndData', dataEnd);

      this.checkMobile();
      window.addEventListener('resize', this.checkMobile);

      return {
        showIndic: true,
        whitePage: false,
        bigPage: false,
        noMargin: false,
        page: null,
      };
    },
    created() {
      this.setIndic(this.$route.fullPath);
      this.checkPageColor(this.$route.fullPath);
      this.page = this.$route.name;
    },
    methods: {
      setIndic(route) {
        if (route === '/') {
          this.showIndic = true;
        } else {
          this.showIndic = false;
        }
      },
      checkPageColor(route) {
        if (route === '/' || route === '/the-end') {
          this.whitePage = false;
        } else {
          this.whitePage = true;
        }

        if (route === '/reglement') {
          this.bigPage = true;
        } else {
          this.bigPage = false;
        }

        if (route === '/biographies' || route === '/the-end') {
          this.noMargin = true;
        } else {
          this.noMargin = false;
        }
      },
      checkMobile() {
        if (window.innerWidth <= 650) {
          this.$store.commit('setIsMobile', true);
        } else {
          this.$store.commit('setIsMobile', false);
        }
      },
    },
    watch: {
      '$route'(to) {
        this.page = to.name;
        this.setIndic(to.fullPath);
        this.checkPageColor(to.fullPath);
      },
    },
    computed: {
      getShowPopin() {
        return this.$store.getters.getShowPopin;
      },
      getMobile() {
        return this.$store.getters.getMobile;
      },
    },
  };
</script>

<style lang="scss">
  @import 'assets/styles/styles';

  #app {
    position: relative;
    height: 100%;
    min-height: 550px;
    background: url('./assets/img/bg_orange.jpg') no-repeat center center;
    background-size: cover;
    @include defaultTransition(.4);
    -webkit-overflow-scrolling: touch; 

    > .wrapper {
      position: relative;
      z-index: 10;
      height: 100%;
      -ms-overflow-x: hidden;
    }

    @include large-desktop {
      &.aventure {
        min-height: 880px;
      }
    }

    @include tablet {
      min-height: 770px;
    }

    @include mobile {
      height: auto;
      
       > .wrapper {
        height: 100%;
        max-width: 100%;
      }     

      .app-content {
        display: block;
        width: 90%;
        margin: auto;
        padding-top: 150px;
      }

      &.biographies {
        .app-content {
          padding-top: 70px;
        }
      }

      &.home {
        height: 100%;
        min-height: 100%;

        .app-content {
          display: flex;
          padding-top: 0;
        }
      }

      &.choice-charac-slide .app-content {
        width: 100%;
      }

      &.aventure {
        height: 100%;
        min-height: 650px;

        .app-content {
          padding-top: 85px;
        }
      }
    }

    &.popin-deploy .app-content {
      z-index: 100;
    }

    &.no-margin {
      > .wrapper {
        height: 100%;
        max-width: 100%;
        overflow-y: scroll;
      }

      .app-content {
        display: block;
        height: auto;
      }

      .app-footer {
        position: initial;
      }
    }

    &.layout--tall {
      height: auto;
      min-height: 100%;
    }

    &.app--white {
      background: url('./assets/img/bg_white.jpg') no-repeat center center;
      background-size: cover;

      @include mobile {
        &.biographies,
        &.contact,
        &.reglement {
          background: $beige;
        }
      }

      &::before,
      &::after {
        position: absolute;
        z-index: 20;
        left: 0;
        right: 0;
        height: 4px;
        background: $orange;
        content: '';
      }

      &::before {
        top: 0;
      }

      &::after {
        bottom: 0;
      }

      .socials a {
        color: $blue;

        &:hover {
          color: $orange;
        }
      }

      .menu button {
        background: $orange;
        border-color: $orange;

        span {
          background: $white;
        }

        &:hover {
          background: $white;

          span {
            background: $orange;
          }
        }
      }

      .menu {
        &::before {
          background: $white;
        }

        nav a:hover {
          color: $orange;
        }
      }
    }
  }

  .app-header {
    position: absolute;
    z-index: 20;
    top: 35px;
    right: 0;
    left: 50%;
    width: 90%;
    // max-width: 90%;
    transform: translateX(-50%);

    @include mobile {
      top: 15px;
    }

    .app-header--left {
      float: left;
    }

    .app-header--right {
      float: right;
      opacity: 0;
      animation: translateXMenu .4s .8s ease-in-out forwards;

      @keyframes translateXMenu {
        from {
          opacity: 0;
          transform: translateX(30px);
        }
        to {
          opacity: 1;
          transform: translateX(0);
        }
      }
    }
  }

  .app-header--logo {
    position: absolute;
    top: -35px;
    padding: 12px 20px 20px;
    background: $white;
    border-radius: 0 0 10px 10px;

    @include tablet {
      padding: 12px 10px 10px;
    }

    @include mobile {
      top: -15px;
      width: 100px;
    }

    a {
      display: block;
      @include defaultTransition(.2);

      &:hover {
        padding-top: 10px;

        @include mobile {
          padding-top: 0;
        }
      }
    }

    img {
      max-width: 100%;

      @include tablet {
        max-width: 80px;
      }
    }
  }

  .app-header--indic {
    color: $white;
    text-align: center;
    opacity: 0;
    animation: translateXIndic .4s .6s ease-in-out forwards;

    @include mobile {
      display: none;
    }

    div {
      border-top: 2px dotted $white;
      border-bottom: 2px dotted $white;
    }

    div:first-child {
      padding: 5px 0;
      line-height: 1;
      border-bottom: 0;
      @include fontSize(50);
    }

    div:last-child {
      padding: 10px 0;
      line-height: 1.3;
      @include fontSize(15);
    }

    @keyframes translateXIndic {
      from {
        opacity: 0;
        transform: translateX(-30px);
      }
      to {
        opacity: 1;
        transform: translateX(0);
      }
    }
  }

  .app-footer {
    position: absolute;
    z-index: 20;
    right: 0;
    bottom: 20px;
    padding: 0 2% 2% 0;

    a {
      display: block;
      float: right;

      img {
        max-width: 50px;
      }
    }

    @include mobile {
      display: none;
    }
  }

  .app-content {
    position: relative;
    display: flex;
    align-items: center;
    // flex-wrap: wrap;
    height: 100%;
  }

  .app-rays {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;

    .app-rays--container {
      width: 100%;
      height: 100%;
      animation: sun-spin 100s linear infinite;
    }

    span {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 100%;
      max-width: 0;
      height: 2px;
      margin-top: -20px;
      transform-origin: 0 50%;
      background: rgba($white, 0.2);
      animation: sun-growth 2s .5s ease-in-out forwards;

      @include mobile {
        background: linear-gradient(to right, rgba($white, .3) 0%,rgba($white, 0) 100%); 
      }
    }

    $rays: 50;
    $step: 360 / $rays;

    @for $i from 1 through $rays {
      span:nth-child(#{$i}) { transform: rotate(#{($i - 1) * $step}deg); }
    }

    @keyframes sun-spin {
      from { transform: rotate(0); }
      to   { transform: rotate(360deg); }
    }

    @keyframes sun-growth {
      from { max-width: 0; }
      to   { max-width: 100% }
    }
  }
</style>



// WEBPACK FOOTER //
// App.vue?4c5b1ad2